var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "loginDiv",
      on: {
        keydown: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          $event.stopPropagation()
          _vm.login()
        }
      }
    },
    [
      _c(
        "v-container",
        { staticClass: "loginFrame" },
        [
          _c("v-layout", { staticClass: "text-xs-left", attrs: { row: "" } }, [
            _c("div", [
              _c("img", {
                staticClass: "ntstLogo",
                attrs: {
                  src: require("../assets/images/Netsmart_logo_people_only.png")
                }
              })
            ]),
            _c("div", [
              _c("p", { staticClass: "netsmartName" }, [_vm._v("Netsmart")]),
              _c("p", { staticClass: "appName" }, [_vm._v("BedBoard")])
            ])
          ]),
          _c(
            "v-flex",
            [
              _c("div", { staticClass: "ntstValueLabel" }, [_vm._v("Scope")]),
              _c("v-text-field", {
                attrs: { readonly: _vm.isBusy, outline: "", required: "" },
                model: {
                  value: _vm.input.scope,
                  callback: function($$v) {
                    _vm.$set(_vm.input, "scope", $$v)
                  },
                  expression: "input.scope"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            [
              _c("div", { staticClass: "ntstValueLabel" }, [
                _vm._v("Username")
              ]),
              _c("v-text-field", {
                attrs: {
                  readonly: _vm.isBusy,
                  "append-icon": "person",
                  outline: "",
                  required: ""
                },
                model: {
                  value: _vm.input.userName,
                  callback: function($$v) {
                    _vm.$set(_vm.input, "userName", $$v)
                  },
                  expression: "input.userName"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            [
              _c("div", { staticClass: "ntstValueLabel" }, [
                _vm._v("Password")
              ]),
              _c("v-text-field", {
                attrs: {
                  readonly: _vm.isBusy,
                  "append-icon": "lock",
                  type: "password",
                  outline: "",
                  required: ""
                },
                model: {
                  value: _vm.input.password,
                  callback: function($$v) {
                    _vm.$set(_vm.input, "password", $$v)
                  },
                  expression: "input.password"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            [
              _c("v-checkbox", {
                attrs: { label: "Remember Username", color: "#757575" },
                model: {
                  value: _vm.rememberMe,
                  callback: function($$v) {
                    _vm.rememberMe = $$v
                  },
                  expression: "rememberMe"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { staticClass: "text-xs-center" },
            [
              !_vm.isBusy
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ntstAppButton",
                      staticStyle: { "margin-bottom": "28px" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.login()
                        }
                      }
                    },
                    [_vm._v("Login")]
                  )
                : _vm._e(),
              _vm.isBusy ? _c("busy-animation") : _vm._e(),
              _vm.isBusy
                ? _c("div", { staticClass: "ntstLoadingLabel" }, [
                    _vm._v(_vm._s(_vm.statusMessage))
                  ])
                : _vm._e()
            ],
            1
          ),
          _c("v-alert", { attrs: { value: _vm.errorMessage, type: "error" } }, [
            _vm._v(_vm._s(_vm.errorMessage))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }